import React from "react";
import { DropdownItem } from "../../shared-components/DropdownCombo";
import LabeledCheckbox from "../../shared-components/LabeledCheckbox";
import { BlueprintMinimalInfo } from "../../api/Blueprints";
import { REPORT_TYPES } from "../../api/Reports";

type Props = {
  blueprintItems: BlueprintMinimalInfo[];
  selections?: BlueprintMinimalInfo[];
  onChange: (active: boolean, bp_uuid: string) => void;
  noHeader?: boolean;
  /** When true, all checkboxes are non-interactive (e.g. report rerun). */
  disabled?: boolean;
};

function buildLabeledItems(
  blueprintItems: BlueprintMinimalInfo[],
  reportType: REPORT_TYPES
): DropdownItem[] {
  return blueprintItems
    .filter((item) => item.report_type === reportType)
    .map((item) => ({
      id: item.blueprint_uuid,
      label: item.name,
    }));
}

function hasItemSelected(selections: BlueprintMinimalInfo[], id: string) {
  return selections.some((selection) => selection.blueprint_uuid === id);
}

const CheckTypesMulti = ({
  blueprintItems,
  selections,
  onChange,
  noHeader = false,
  disabled = false,
}: Props) => {
  const misconductItems = buildLabeledItems(
    blueprintItems,
    REPORT_TYPES.MISCONDUCT
  );
  const threeSixtyItems = buildLabeledItems(
    blueprintItems,
    REPORT_TYPES.THREE_SIXTY
  );

  function onSourceChange(evt: React.ChangeEvent<HTMLInputElement>) {
    onChange(evt.target.checked, evt.target.id);
  }

  return (
    <div>
      {!noHeader && misconductItems.length > 0 && (
        <div className="font-bold pb-2 text-sm">Misconduct</div>
      )}
      <div>
        {misconductItems.map((item) => (
          <LabeledCheckbox
            key={item.id}
            id={item.id}
            label={item.label}
            name={item.label}
            onChange={onSourceChange}
            disabled={disabled}
            checked={hasItemSelected(selections || [], item.id)}
          ></LabeledCheckbox>
        ))}
      </div>
      {!noHeader && threeSixtyItems.length > 0 && (
        <div className="font-bold pb-2 text-sm">360</div>
      )}
      <div>
        {threeSixtyItems.map((item) => (
          <LabeledCheckbox
            key={item.id}
            id={item.id}
            label={item.label}
            name={item.label}
            onChange={onSourceChange}
            disabled={disabled}
            checked={hasItemSelected(selections || [], item.id)}
          ></LabeledCheckbox>
        ))}
      </div>
    </div>
  );
};

export default CheckTypesMulti;
